import React, { useEffect, useState } from "react";
import { useFormContext, useController } from "react-hook-form";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { checkModuleAccess, isSuperAdmin } from "../../../Functions/permissions";
import { useGetIdentity, usePermissions } from "react-admin";
import { typesofUsers } from "../../../config";
import { RootState } from "../../../Store/store";
import { useSelector } from "react-redux";
import { useUserRole } from "../../../ContextApi/UserRoleContext";
import { JSONTree } from "react-json-tree";

const InputSSNField = ({ labelRequired = true, label, source, notRequired = false, type = 'text', placeholder, handleOnChange = (e) => { } }) => {
  const { permissions } = usePermissions();
  const { data: getUserData } = useGetIdentity();
  const required = !notRequired;
  const { control } = useFormContext();
  const moduleAccess = isSuperAdmin(checkModuleAccess(permissions, "Settings", "Show/Edit SSN Number"), getUserData?.userrole)
  const {
    field,
    fieldState: { error },
  } = useController({
    name: source,
    control,
  });

  const calculateMaskedState = (getUserData) => {
    return !(getUserData?.userrole.toLowerCase() == typesofUsers.docuverusSuperAdmin.toLowerCase()
      || getUserData?.userrole.toLowerCase() == typesofUsers.docuverusAdmin.toLowerCase()
      || getUserData?.userrole.toLowerCase() == typesofUsers.applicant.toLowerCase()
      || getUserData?.userrole.toLowerCase() == typesofUsers.coApplicant.toLowerCase()
      || getUserData?.userrole.toLowerCase() == typesofUsers.coSigner.toLowerCase())
      ? true : false;
  };

  const [isMasked, setIsMasked] = useState(false);

  useEffect(() => {
    setIsMasked(calculateMaskedState(getUserData) && !moduleAccess);
  }, [getUserData])

  const formatSSN = (value) => {
    const rawValue = value.replace(/\D/g, ""); // Remove non-numeric characters
    if (rawValue.length === 9) {
      return isMasked ? `***-**-${rawValue.slice(5, 9)}` : `${rawValue.slice(0, 3)}-${rawValue.slice(3, 5)}-${rawValue.slice(5, 9)}`;
    }
    return rawValue;
  };

  const handleChange = (e) => {
    const rawValue = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
    if (rawValue.length <= 9) {
      field.onChange(rawValue);
      handleOnChange(e);
    }
  };

  return (
    <div className="emp-inputs form-label">
      {label !== '' && labelRequired && (
        <label className={`lable_title ${error && "text-danger"}`} htmlFor={source}>
          {label} {!notRequired && <span>*</span>}
        </label>
      )}
      <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
        <input
          disabled={isMasked}
          type={type}
          placeholder={placeholder || label}
          className={`form-control cus-input-control ${required && !field.value && "is-warning"} ${error && "is-invalid"}`}
          id={source}
          value={formatSSN(field.value || "")}
          onChange={handleChange}
          onBlur={field.onBlur}
          maxLength={11}
          autoComplete="off"
          style={{ paddingRight: "40px" }}
        />
        {(moduleAccess && !calculateMaskedState(getUserData)) && <button
          type="button"
          onClick={() => setIsMasked(!isMasked)}
          style={{ position: "absolute", right: "30px", top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer" }}
        >
          {isMasked ? <FaEyeSlash size={18} color="#aaa" /> : <FaEye size={18} color="#555" />}
        </button>}
      </div>
      {error && <div className="invalid-feedback" style={{ display: "block", fontSize: "70%" }}>{error.message}</div>}
    </div>
  );
};

export default InputSSNField;


